import { createEvent } from 'effector';

export const logOutUser = createEvent();

export const getOrdersList = createEvent<{
  limit: number;
  offset: number;
}>();
